import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { ButtonReset } from '@helpers/global';
import styled from 'styled-components';
const Nav = styled.nav `
  display: flex;
  height: var(--headerTopBarHeight);
  margin-right: -20px;
  ${transition('height', '0.15s')};

  &[data-visible='false'] {
    overflow: hidden;
  }
`;
const List = styled.ul `
  display: inherit;
  place-items: center;
`;
const Item = styled.li `
  position: relative;
  display: inline-flex;
  place-items: center;
  height: 100%;
  padding: 0 20px;
`;
const Link = styled.a `
  ${ButtonReset};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 14px;
  color: var(--fgColor);
  text-decoration: none;

  &:hover,
  &:focus-visible {
    color: ${brand.primary.purple.base};
    text-decoration: underline;
    text-underline-offset: 3px;
  }

  svg {
    --iconSize: 8px;

    width: var(--iconSize);
    height: var(--iconSize);
    flex-shrink: 0;
    color: inherit;
    opacity: 0.6;
  }
`;
const LinkButton = styled.button `
  ${ButtonReset};
  display: flex;
  align-items: center;
  font-size: 14px;
  color: var(--fgColor);
  text-decoration: none;
  height: 100%;

  span {
    position: relative;
    top: 1px;
  }

  &:hover,
  &:focus-visible {
    color: ${brand.primary.purple.base};
    text-decoration: underline;
    text-underline-offset: 3px;
  }
`;
const DropdownList = styled.ul `
  position: absolute;
  z-index: 10;
  top: 100%;
  left: 4px;
  width: 200px;
  background-color: ${brand.tertiary.nearlyWhite.light};
  opacity: 0;
  pointer-events: none;
  ${transition('opacity', '0.15s')};

  ${Item}:hover &,
  ${Item}:focus-within & {
    opacity: 1;
    pointer-events: auto;
  }

  ${Item}:last-child &,
  ${Item}:nth-last-child(2) & {
    left: auto;
    right: calc((var(--sitePadding) - 20px) * -1);
  }
`;
const DropdownItem = styled.li `
  &:not(:last-child) {
    border-bottom: 1px solid ${brand.secondary.grey.light};
  }
`;
const DropdownLink = styled.a `
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  font-size: 14px;
  padding: 8px 16px;
  color: var(--fgColor);
  text-decoration: none;

  &:hover,
  &:focus-visible {
    color: ${brand.primary.purple.base};
    background-color: ${brand.tertiary.nearlyWhite.mid};
    text-decoration: underline;
    text-underline-offset: 3px;
  }

  svg {
    --iconSize: 12px;

    width: var(--iconSize);
    height: var(--iconSize);
    flex-shrink: 0;
  }
`;
const SecondaryNavigationStyles = {
    Nav,
    List,
    Item,
    Link,
    LinkButton,
    DropdownList,
    DropdownItem,
    DropdownLink,
};
export default SecondaryNavigationStyles;
